<template>
    <transition
        :css="false"
        @enter="enter"
        @leave="leave"
        @enter-cancelled="enterCancelled"
        @leave-cancelled="leaveCancelled"
    >
        <a class="pageTopBtn"
           @click.stop.prevent="scroll"
           v-show="isOpen"
        >
            <i class="bi bi-chevron-double-up fz_18 fz_md_22"></i>
        </a>
    </transition>
</template>

<script>
import Velocity from 'velocity-animate';

export default {
    data() {
        return {
            dir: DIR,
            isOpen: false,
        }
    },
    created() {
        window.addEventListener('scroll', () => {
            this.isOpen = (300 <= window.scrollY);
        }, {passive: true, capture: false})
    },
    methods: {
        scroll() {
            Velocity(document.getElementsByTagName('body')[0], 'scroll', {duration: 1000, easing: 'easeIn'})
        },
        enter(el, done) {
            Velocity(el, {opacity: [0.9, 0]}, {duration: 500, mobileHA: false, complete: done})
        },
        leave(el, done) {
            Velocity(el, {opacity: [0, 0.9]}, {duration: 500, mobileHA: false, complete: done})
        },
        enterCancelled(el) {
            Velocity(el, 'stop');
        },
        leaveCancelled(el) {
            Velocity(el, 'stop');
        },
    },
}
</script>


<style scoped lang="scss">
@import 'src/assets/scss/modules/variables';

.pageTopBtn {
    z-index: 800;
    position: fixed;
    bottom: 15px;
    right: 15px;
    width: 40px;
    height: 40px;
    border-radius: 100vh;
    background-color: $main;
    @media ($min-md) {
        width: 50px;
        height: 50px;
    }
    @media ($min-xxl) {
        bottom: 30px;
        right: 10%;
    }

    .bi {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -60%);
        color: $accent3;
    }
}

</style>
